/* Desktop nav intent. CSS :hover and :focus-within open the panels when this
   script has not marked the nav ready. Once ready, hover waits briefly so a
   pass across the bar does not flash a panel, and a move into the panel (or
   across the small gap under the link) does not close it. */
(function () {
  const nav = document.querySelector('.sw-nav');
  if (!nav) return;

  const OPEN_MS = 80;
  const CLOSE_MS = 200;
  const hoverNone = window.matchMedia('(hover: none)');
  let openTimer = 0;
  let closeTimer = 0;

  const items = () => [...nav.querySelectorAll('.sw-nav__item--mega, .sw-nav__item--drop')];

  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    const trigger = item.querySelector('.sw-nav__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    items().forEach((item) => {
      if (item !== except) setOpen(item, false);
    });
  }

  function openItem(item, delay) {
    window.clearTimeout(closeTimer);
    window.clearTimeout(openTimer);
    const switching = items().some((other) => other !== item && other.classList.contains('is-open'));
    const apply = () => {
      closeAll(item);
      setOpen(item, true);
    };
    if (switching || !delay) apply();
    else openTimer = window.setTimeout(apply, delay);
  }

  function scheduleClose(item) {
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => {
      if (item.contains(document.activeElement)) return;
      setOpen(item, false);
    }, CLOSE_MS);
  }

  items().forEach((item) => {
    const trigger = item.querySelector('.sw-nav__trigger');

    item.addEventListener('pointerenter', () => {
      if (hoverNone.matches) return;
      openItem(item, OPEN_MS);
    });

    item.addEventListener('pointerleave', (event) => {
      if (hoverNone.matches) return;
      if (item.contains(event.relatedTarget)) return;
      scheduleClose(item);
    });

    item.addEventListener('focusin', () => {
      if (item.dataset.swSuppress === '1') return;
      openItem(item, 0);
    });

    item.addEventListener('focusout', (event) => {
      if (item.contains(event.relatedTarget)) return;
      scheduleClose(item);
    });

    if (!trigger) return;

    trigger.addEventListener('click', (event) => {
      if (!hoverNone.matches || item.classList.contains('is-open')) return;
      event.preventDefault();
      openItem(item, 0);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const item = items().find((entry) => entry.classList.contains('is-open'));
    if (!item) return;
    const trigger = item.querySelector('.sw-nav__trigger');
    item.dataset.swSuppress = '1';
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    setOpen(item, false);
    if (trigger) trigger.focus();
  });

  nav.addEventListener(
    'focusout',
    (event) => {
      const item = event.target.closest && event.target.closest('.sw-nav__item');
      if (!item || item.dataset.swSuppress !== '1') return;
      if (item.contains(event.relatedTarget)) return;
      delete item.dataset.swSuppress;
    },
    true
  );

  document.addEventListener('pointerdown', (event) => {
    if (nav.contains(event.target)) return;
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    closeAll(null);
  });

  nav.classList.add('is-ready');

  window.SwNav = {
    close() {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      closeAll(null);
    },
  };
})();
